import { useTranslation } from 'react-i18next';
import { Button } from '../design-system/primitives/Button/Button.js';
import { Modal } from '../design-system/primitives/Modal/Modal.js';

type SkipLanguageCheckModalProps = {
  open: boolean;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function SkipLanguageCheckModal({
  open,
  pending = false,
  onCancel,
  onConfirm,
}: SkipLanguageCheckModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onCancel();
      }}
      title={t('interview.languageCheck.skipModal.title', {
        defaultValue: 'Skip the language check?',
      })}
      description={t('interview.languageCheck.skipModal.description', {
        defaultValue:
          "You won't get a language proficiency assessment for this interview. You can't go back and take it later once you skip.",
      })}
      size="sm"
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button type="button" variant="secondary" size="md" onClick={onCancel}>
            {t('common.cancel', { defaultValue: 'Cancel' })}
          </Button>
          <Button type="button" variant="danger" size="md" disabled={pending} onClick={onConfirm}>
            {t('interview.languageCheck.skipModal.confirmButton', {
              defaultValue: 'Skip anyway',
            })}
          </Button>
        </div>
      }
    >
      <></>
    </Modal>
  );
}
